import { Component, computed, input } from '@angular/core';
import { ProjectLinkPipe } from '@web/shared/pipes/project-link.pipe';
import { ProjectCodeTagComponent } from '../../project-code-tag.component';
import { SearchProjectEntry } from '../interfaces/search-project-entry.interface';
import { DetailItem, SearchItemBaseComponent } from './search-item-base.component';
import { SearchStatusChipComponent } from './search-status-chip.component';

@Component({
  selector: 'app-search-project-item',
  imports: [ProjectCodeTagComponent, ProjectLinkPipe, SearchItemBaseComponent, SearchStatusChipComponent],
  template: `
    @let _item = item();

    <app-search-item-base
      icon="pi pi-file-check"
      color="text-soe-sage-mist"
      [detailRouterLink]="_item | projectLink"
      [detailItems]="detailItems()"
    >
      <ng-template #title>
        <div [innerHTML]="_item.name"></div>
      </ng-template>

      <ng-template #codeTag>
        <app-project-code-tag [project]="_item" [clickable]="false" />
      </ng-template>

      <ng-template #statusChip>
        @if (_item.statusName) {
          <app-search-status-chip
            [name]="_item.statusName"
            [backgroundColor]="_item.statusColor"
            [textColor]="_item.statusTextColor"
          />
        }
      </ng-template>
    </app-search-item-base>
  `,
})
export class SearchProjectItemComponent {
  readonly item = input.required<SearchProjectEntry>();

  readonly detailItems = computed<DetailItem[]>(() => []);
}
